"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactBaseTable = _interopRequireWildcard(require("react-base-table"));

var _reactFullScreen = require("react-full-screen");

var _loader = _interopRequireDefault(require("../../loader"));

var _context4 = require("../context");

var _actions = require("../actions");

var _utils = require("../utils");

var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell"));

var _SortIndicator = _interopRequireDefault(require("./SortIndicator"));

var _ExpandIcon = _interopRequireDefault(require("./ExpandIcon"));

var _HeaderRow = _interopRequireDefault(require("./HeaderRow"));

var _CheckboxSelect = _interopRequireDefault(require("./CheckboxSelect"));

var _RadioSelect = _interopRequireDefault(require("./RadioSelect"));

var _LoadMoreLoader = _interopRequireDefault(require("./LoadMoreLoader"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Table = /*#__PURE__*/(0, _react.forwardRef)(function (_, ref) {
  var _context, _context2;

  var handleFullScreen = (0, _reactFullScreen.useFullScreenHandle)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isFullScreen = _useState2[0],
      setIsFullScreen = _useState2[1];

  var _useTable = (0, _context4.useTable)(),
      tableId = _useTable.tableId,
      enablePersistConfig = _useTable.enablePersistConfig,
      fireAction = _useTable.fireAction,
      data = _useTable.data,
      columns = _useTable.columns,
      responsive = _useTable.responsive,
      isInitialWidthSet = _useTable.isInitialWidthSet,
      maxHeaderCount = _useTable.maxHeaderCount,
      isExpandable = _useTable.isExpandable,
      isSelectable = _useTable.isSelectable,
      multiSelect = _useTable.multiSelect,
      uniqueDataKey = _useTable.uniqueDataKey,
      selectedRows = _useTable.selectedRows,
      allRowsSelected = _useTable.allRowsSelected,
      selectedRow = _useTable.selectedRow,
      onRowClick = _useTable.onRowClick,
      getRowClassName = _useTable.getRowClassName,
      disabledRows = _useTable.disabledRows,
      controlSelection = _useTable.controlSelection,
      hideHeader = _useTable.hideHeader,
      isLoading = _useTable.isLoading,
      isLoadingMore = _useTable.isLoadingMore,
      onLoadMore = _useTable.onLoadMore,
      loadedAll = _useTable.loadedAll,
      fixSelectionColumn = _useTable.fixSelectionColumn,
      estimatedRowHeight = _useTable.estimatedRowHeight,
      rowRenderer = _useTable.rowRenderer,
      enableRowSpan = _useTable.enableRowSpan,
      emptyRenderer = _useTable.emptyRenderer,
      footerRenderer = _useTable.footerRenderer,
      footerHeight = _useTable.footerHeight,
      sortBy = _useTable.sortBy,
      sortOrder = _useTable.sortOrder,
      onSort = _useTable.onSort,
      enableConfiguration = _useTable.enableConfiguration,
      enableFullScreen = _useTable.enableFullScreen,
      enableExportToCsv = _useTable.enableExportToCsv,
      toolbarChildren = _useTable.toolbarChildren,
      defaultExpandedRows = _useTable.defaultExpandedRows,
      expandedRows = _useTable.expandedRows,
      _onRowExpand = _useTable.onRowExpand,
      controlExpansion = _useTable.controlExpansion;

  var onFullScreenChange = (0, _react.useCallback)(function (active) {
    setIsFullScreen(active);
  }, [setIsFullScreen]);
  var handleResize = (0, _react.useCallback)(function (dimensions) {
    if (!isInitialWidthSet && !responsive && (0, _utils.shouldReallySetInitialWidth)(columns, tableId, enablePersistConfig)) {
      fireAction((0, _actions.setColumnsInitialWidth)(dimensions.width));
    }

    fireAction((0, _actions.updateStateValues)({
      tableWidth: dimensions.width
    }));
  }, [fireAction, isInitialWidthSet, columns, tableId, enablePersistConfig, responsive]);
  /* istanbul ignore next */
  // We cannot test scroll events in jsdom env because id doesnt render the layout.
  // Hence we get zero offset for all elements

  var onScrollEndReached = (0, _react.useCallback)(function () {
    if ((0, _utils.isFunction)(onLoadMore) && !isLoading && !isLoadingMore && !loadedAll) {
      fireAction((0, _actions.loadMoreDataStart)());
      var promise = onLoadMore(data.length);

      if (promise instanceof _promise["default"]) {
        promise.then(function (d) {
          fireAction((0, _actions.loadMoreData)(d));
        })["finally"](function () {
          fireAction((0, _actions.loadMoreDataStop)());

          if (allRowsSelected && !controlSelection) {
            fireAction((0, _actions.toggleSelectAll)(allRowsSelected));
          }
        });
      }
    }
  }, [onLoadMore, fireAction, isLoading, isLoadingMore, loadedAll, data, allRowsSelected, controlSelection]);
  var tableColumns = (0, _filter["default"])(_context = (0, _concat["default"])(_context2 = [isSelectable ? (0, _utils.getSelectionColumn)(multiSelect ? _CheckboxSelect["default"] : _RadioSelect["default"], multiSelect, fixSelectionColumn) : null]).call(_context2, (0, _toConsumableArray2["default"])(columns))).call(_context, Boolean); // console.log(columns);

  var tableRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      scrollToTop: function scrollToTop() {
        if (tableRef.current && data && data.length > 0) {
          tableRef.current.scrollToRow(0, "start");
        }
      },
      scrollToBottom: function scrollToBottom() {
        if (tableRef.current && data && data.length > 0) {
          tableRef.current.scrollToRow(data.length, "end");
        }
      },
      scrollToRowIndex: function scrollToRowIndex(rowIndex) {
        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "start";

        if (tableRef.current && data && data.length > 0) {
          tableRef.current.scrollToRow(rowIndex, direction);
        }
      },
      checkAllRows: function checkAllRows() {
        if (!controlSelection) {
          fireAction((0, _actions.toggleSelectAll)(true));
        }
      },
      uncheckAllRows: function uncheckAllRows() {
        if (!controlSelection) {
          fireAction((0, _actions.toggleSelectAll)(false));
        }
      }
    };
  });
  var shouldShowToolbar = (0, _react.useMemo)(function () {
    return enableFullScreen || enableExportToCsv || enableConfiguration || toolbarChildren;
  }, [enableFullScreen, enableExportToCsv, enableConfiguration, toolbarChildren]);
  return /*#__PURE__*/_react["default"].createElement(_reactBaseTable.AutoResizer, null, function (_ref) {
    var w = _ref.width,
        h = _ref.height;
    return /*#__PURE__*/_react["default"].createElement(_reactFullScreen.FullScreen, {
      handle: handleFullScreen,
      onChange: onFullScreenChange
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: isFullScreen ? {
        height: "100vh"
      } : {
        height: "".concat(h, "px"),
        width: "".concat(w, "px")
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactBaseTable.AutoResizer, {
      onResize: handleResize
    }, function (_ref2) {
      var _context3;

      var width = _ref2.width,
          height = _ref2.height;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, shouldShowToolbar && /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
        width: width,
        handleFullScreen: handleFullScreen,
        isFullScreen: isFullScreen,
        tableRef: tableRef
      }), /*#__PURE__*/_react["default"].createElement(_reactBaseTable["default"], {
        ref: tableRef,
        classPrefix: _utils.CLASS_PREFIX,
        width: width,
        height: height - ((0, _utils.isFunction)(footerRenderer) ? footerHeight : 0) - (shouldShowToolbar ? 40 : 0),
        rowKey: uniqueDataKey,
        columns: tableColumns,
        fixed: !responsive,
        useIsScrolling: true,
        sortBy: {
          key: sortBy,
          order: sortOrder
        },
        onColumnSort: function onColumnSort(sortObj) {
          if ((0, _utils.isFunction)(onSort)) {
            onSort(sortObj.key, sortObj.order);
          }
        },
        headerHeight: hideHeader ? 0 : (0, _fill["default"])(_context3 = Array(maxHeaderCount)).call(_context3, 40),
        estimatedRowHeight: enableRowSpan ? undefined : estimatedRowHeight,
        data: data,
        components: {
          SortIndicator: _SortIndicator["default"],
          ExpandIcon: _ExpandIcon["default"],
          TableHeaderCell: _TableHeaderCell["default"]
        },
        headerRenderer: function headerRenderer(props) {
          return /*#__PURE__*/_react["default"].createElement(_HeaderRow["default"], (0, _extends2["default"])({}, props, {
            maxHeaderCount: maxHeaderCount
          }));
        },
        onEndReachedThreshold: 20,
        onEndReached: onScrollEndReached,
        rowProps: function rowProps(_ref3) {
          var rowData = _ref3.rowData,
              rowIndex = _ref3.rowIndex;
          var rowId = rowData[uniqueDataKey];
          return {
            onClick: function onClick(e) {
              if (e.target.classList.contains("oui-custom-control-label")) {
                return;
              }

              if (!e.rowId && !controlSelection && isSelectable && !(0, _includes["default"])(disabledRows).call(disabledRows, rowId)) {
                if (multiSelect) {
                  fireAction((0, _actions.toggleRowSelection)(rowId));
                } else {
                  fireAction((0, _actions.selectSingleRow)(rowId));
                }
              }

              if ((0, _utils.isFunction)(onRowClick)) {
                onRowClick(rowData, rowIndex);
              }
            }
          };
        },
        rowClassName: function rowClassName(_ref4) {
          var rowData = _ref4.rowData,
              rowIndex = _ref4.rowIndex;
          var rowId = rowData[uniqueDataKey];
          var userClassName = enableRowSpan ? "".concat(_utils.CLASS_PREFIX, "__rowSpan") : "";

          if ((0, _utils.isFunction)(getRowClassName)) {
            userClassName += " ".concat(getRowClassName(rowData, rowIndex));
          } else if ((0, _utils.isString)(getRowClassName)) {
            userClassName += " ".concat(getRowClassName);
          }

          return (0, _classnames["default"])((0, _defineProperty2["default"])({}, "".concat(_utils.CLASS_PREFIX, "__row--selected"), isSelectable && (!multiSelect && selectedRow === rowId || (0, _includes["default"])(selectedRows).call(selectedRows, rowId))), (0, _trim["default"])(userClassName).call(userClassName));
        },
        overlayRenderer: function overlayRenderer() {
          if (isLoading) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "oui-h-100"
            }, /*#__PURE__*/_react["default"].createElement(_loader["default"], {
              isLoading: true,
              className: "oui-h-100 data-grid-loading-overlay"
            }));
          }

          if (isLoadingMore) {
            return /*#__PURE__*/_react["default"].createElement(_LoadMoreLoader["default"], null);
          }

          return null;
        },
        emptyRenderer: (0, _utils.isFunction)(emptyRenderer) ? emptyRenderer : function () {
          return emptyRenderer;
        },
        footerHeight: (0, _utils.isFunction)(footerRenderer) ? footerHeight : 0,
        footerRenderer: (0, _utils.isFunction)(footerRenderer) ? footerRenderer : null,
        defaultExpandedRowKeys: defaultExpandedRows,
        expandedRowKeys: expandedRows,
        onRowExpand: function onRowExpand(p) {
          if (!controlExpansion) {
            var rowId = p.rowData[uniqueDataKey];
            fireAction((0, _actions.toggleRowExpansion)(rowId));
          }

          if ((0, _utils.isFunction)(_onRowExpand)) {
            _onRowExpand(p);
          }
        },
        expandIconProps: function expandIconProps(obj) {
          return obj;
        },
        expandColumnKey: isExpandable ? isSelectable ? tableColumns[1].key : tableColumns[0].key : null,
        overscanRowCount: enableRowSpan ? 20 : 1,
        rowRenderer: (0, _utils.isFunction)(rowRenderer) ? function (_ref5) {
          var rowData = _ref5.rowData,
              cells = _ref5.cells,
              rowIndex = _ref5.rowIndex;
          return rowRenderer(rowData, cells, rowIndex, columns);
        } : null,
        cellProps: function cellProps(_ref6) {
          var column = _ref6.column;
          return {
            onClick: function onClick(e) {
              if (enableRowSpan && column.key && column.key !== "__selection__") {
                e.stopPropagation();
              }
            }
          };
        },
        onColumnResizeEnd: function onColumnResizeEnd(column) {
          fireAction((0, _actions.onColumnResizeEnd)(column));
        }
      }));
    })));
  });
});
var _default = Table;
exports["default"] = _default;